import { useEffect, useState } from 'react';
import { logger } from '@/platform/logger';

const TEXT: Record<string, string> = {
  RevisionConflictError:
    '다른 탭이나 기기에서 먼저 바뀐 기록이라 저장하지 않았습니다. 화면을 새로고침해 최신 내용을 확인하세요.',
  StorageFullError: '기기 저장 공간이 부족해 저장하지 못했습니다. 기존 데이터는 그대로입니다.',
  InvariantError: '승인된 기록 등 바꿀 수 없는 내용이라 저장하지 않았습니다.',
  ValidationError: '입력 형식이 맞지 않아 저장하지 않았습니다.',
  IntegrityError: '데이터를 읽는 중 손상이 발견되었습니다. 설정 → 데이터 점검을 실행하세요.',
};

/**
 * 처리되지 않은 오류를 조용히 삼키지 않고 화면에 알린다 (안전장치).
 * 내용 원문은 로그에 남기지 않고 오류 종류만 기록한다.
 */
export function ErrorBanner() {
  const [msg, setMsg] = useState<string | null>(null);
  useEffect(() => {
    const show = (e: unknown) => {
      const name = (e as Error)?.name ?? 'Error';
      logger.error('ui.unhandled', { name });
      setMsg(TEXT[name] ?? '작업 중 오류가 발생했습니다. 입력한 내용이 저장되었는지 확인해 주세요.');
    };
    const onRejection = (ev: PromiseRejectionEvent) => show(ev.reason);
    const onError = (ev: ErrorEvent) => show(ev.error);
    window.addEventListener('unhandledrejection', onRejection);
    window.addEventListener('error', onError);
    return () => {
      window.removeEventListener('unhandledrejection', onRejection);
      window.removeEventListener('error', onError);
    };
  }, []);
  if (!msg) return null;
  return (
    <div role="alert" className="banner warn-banner error-banner">
      {msg}
      <button type="button" onClick={() => setMsg(null)}>
        닫기
      </button>
    </div>
  );
}
